import { render, staticRenderFns } from "./ReviewItemText.vue?vue&type=template&id=0a18bc0e&scoped=true"
import script from "./ReviewItemText.vue?vue&type=script&lang=ts"
export * from "./ReviewItemText.vue?vue&type=script&lang=ts"
import style0 from "./ReviewItemText.vue?vue&type=style&index=0&id=0a18bc0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a18bc0e",
  null
  
)

export default component.exports